import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CompactTable } from '@table-library/react-table-library/compact';
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';
import { usePagination } from "@table-library/react-table-library/pagination";
import { FiFilter } from "react-icons/fi";
import { getImage } from "../../utils";

import NotFoundWidget from '../../components/widgets/NotFound';

import { acceptWithdraw, rejectWithdraw, } from "../../store/wallet/walletActions";
import { TablePagination } from "../../components/global/table-pagination";
import moment from "moment";

const WithdrawList = ({ setIsRequest, nodes, setNodes }) => {
    const dispatch = useDispatch()
    const { currentProfile } = useSelector(state => state.profile)
    const [filter, setFilter] = useState([]);

    const COLUMNS = [
        {
            label: 'Request Date',
            renderCell: (item) => <p className="capitalize font-medium text-nt-blue">{moment(item.createdAt).format("YYYY-MM-DD HH:mm")}</p>,
            pinLeft: true,

        },
        {
            label: 'Amount',
            renderCell: (item) => item.amount + "€",
            pinLeft: true,

        },
        {
            label: 'PayPal Email',
            renderCell: (item) => item.email,
            pinLeft: true,
        },
        {
            label: 'Status',
            renderCell: (item, index) => {
                return <StatusTag status={item.status} />
            },
            pinLeft: true,

        },
    ];

    if (currentProfile?.role === 1) {
        COLUMNS.unshift({
            label: 'Tutor',
            renderCell: (item, index) => {
                return <div className="flex gap-2 capitalize text-nt-blue items-center">
                    {item.tutor?.userId?.avatar?.path ? <img className="h-[50px] w-[50px] rounded-full" src={getImage(item.tutor?.userId?.avatar?.path)} alt="" /> : ''}
                    {item.tutor?.userId ? item.tutor?.userId?.firstName + " " + item.tutor?.userId?.lastName : ''}
                </div>
            },
            pinLeft: true,
        })
        COLUMNS.push({
            label: 'Actions',
            renderCell: (item, index) => {
                return <>{item.status == -1 ? <div className="flex gap-1">
                    <button type="button" className="rounded-md bg-nt-blue text-white px-2 py-1" onClick={() => handleAcceptWithdraw(item._id)}>Approve</button>
                    <button type="button" className="rounded-md bg-nt-red text-white px-2 py-1" onClick={() => handleRejectWithdraw(item._id)}>Decline</button>
                </div> : ''}</>
            },
            pinLeft: true,
        })
    }

    const handleAcceptWithdraw = (id) => {
        dispatch(acceptWithdraw(id))
            .unwrap()
            .then(() => {
                setNodes((n) => n.map(k => ({ ...k, status: k._id === id ? 1 : k.status })))
            })
    }

    const handleRejectWithdraw = (id) => {
        dispatch(rejectWithdraw(id))
            .unwrap()
            .then(() => {
                setNodes((n) => n.map(k => ({ ...k, status: k._id === id ? 0 : k.status })))
            })
    }

    const StatusTag = ({ status }) => {
        if (status === -1) {
            return <span className={`bg-nt-blue text-white px-2 rounded py-1 inline-block`}>Pending</span>
        } else if (status === 1) {
            return <span className={`bg-green text-white px-2 rounded py-1 inline-block`}>Accepted</span>
        } else if (status === 0) {
            return <span className={`bg-red text-white px-2 rounded py-1 inline-block`}>Rejected</span>
        }
    }
    const theme = useTheme([getTheme(), {
        HeaderRow: `color: #191D51;`,
        Table: `--data-table-library_grid-template-columns: ${currentProfile?.role == 1 ? 'auto auto' : ''} auto auto auto auto ; width:auto;min-width:auto;min-height:auto;`
    }]);

    let data = { nodes };

    data = {
        nodes: data.nodes.filter((item) =>
            (filter.length && filter.includes(item.status) || filter.length === 0)
        ),
    };

    const pagination = usePagination(data, {
        state: {
            page: 0,
            size: 5,
        },
    });

    const pageButtonCount = 2;
    const totalPages = pagination.state.getTotalPages(data.nodes)
    const pages = pagination.state.getPages(data.nodes);
    
    const toggleFilter = (status) => {
        pagination.fns.onSetPage(0)
        if (filter.includes(status))
            setFilter(x => x.filter(v => v != status))
        else
            setFilter(x => [...x, status])
    }

    const filterChipClass = (status) =>
        `${filter.includes(status) ? "bg-nt-blue text-white border-nt-blue" : "text-nt-blue bg-white border-nt-blue/30 hover:bg-nt-grey/20"} border select-none rounded-full py-1.5 px-3 cursor-pointer text-sm font-medium transition-colors`;

    return <div className="w-full">
        <div className="bg-white p-4 sm:p-5 rounded-2xl border border-nt-blue/10 shadow-sm">
            <div className="mb-5 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h2 className="text-nt-blue font-semibold text-lg">Withdrawal Requests</h2>
                    <p className="text-sm text-gray-500 mt-1">Track request status and manage payouts.</p>
                </div>
            </div>

            <div className="flex gap-2 mb-5 mt-4 items-center flex-wrap">
                <FiFilter className="text-nt-blue mr-1" size={18} />
                <span onClick={() => toggleFilter(-1)} className={filterChipClass(-1)}>Pending</span>
                <span onClick={() => toggleFilter(1)} className={filterChipClass(1)}>Accepted</span>
                <span onClick={() => toggleFilter(0)} className={filterChipClass(0)}>Rejected</span>
            </div>

            <div className="rounded-xl border border-nt-blue/10 overflow-hidden">
                <CompactTable columns={COLUMNS} layout={{ custom: true, horizontalScroll: true, }} data={data} theme={theme} pagination={pagination} />
            </div>
            {nodes.length === 0 ? <NotFoundWidget message="No Withdrawal History" /> : null}

            {totalPages > 0 ? <TablePagination
                pageButtonCount={pageButtonCount}
                totalPages={totalPages}
                pagination={pagination}
                pages={pages}
            /> : null}
        </div>
    </div>
}
export { WithdrawList }